// extracted by mini-css-extract-plugin
module.exports = {"cell-price":"CellWrapper_cell-price__A7bYB","cell-cdo":"CellWrapper_cell-cdo__5Nh9h","cell-price-generics":"CellWrapper_cell-price-generics__ByYrG"};